export const fmtUSD = (value, options = {}) => {
  const { maximumFractionDigits = 2, minimumFractionDigits = 2 } = options;
  return `$${Number(value || 0).toLocaleString(undefined, {
    maximumFractionDigits,
    minimumFractionDigits,
  })}`;
};

export const formatFP = (value) => {
  const amount = Number(value || 0);
  return (Number.isFinite(amount) ? amount : 0).toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
};

export const fmtFP = (value) => `${formatFP(value)} FP`;

export const fmtGameCredits = (value) => fmtUSD(value);
